module.exports = __webpack_public_path__ + "static/media/cookiewich@2x.a6b17638.png";